/* eslint-disable camelcase */
import parse from 'html-react-parser';
import { getLanguage, getPageImage, imagePrettyUrl } from "~helpers/getters";
import {
  getRobotOptions,
  getCanonicalUrl,
  transformMetaTitle,
  getTwitterUsername,
  getLocale,
} from "~helpers/head";



export default (page, isTracker) => { 
  const { relation, meta_title, meta_description, relation_type, siteInfo } = page;
  const pageImage = getPageImage(page) || imagePrettyUrl(siteInfo?.site_logo);
  const parsedMetaDescr = meta_description ? parse(meta_description) : '';
  const metaTitle = transformMetaTitle(relation, meta_title, relation_type);
  const twitterUsername = getTwitterUsername(page.siteSchema?.twitter);

  
  return [
  { type: "meta", name: "description", content: page.meta_description },
  {
    type: "meta",
    name: "robots",
    content: getRobotOptions(page.robot_options),
  },
  { type: "meta", property: "og:title", content: metaTitle},
  {
    type: "meta",
    property: "og:site_name",
    content: siteInfo?.site_name ? siteInfo?.site_name : "",
  },
  { type: "meta", property: "og:description", content: parsedMetaDescr },
  {
    type: "meta",
    property: "og:type",
    content: page.path === "/" ? "website" : "article",
  },
  { type: "meta", property: "og:image", content: pageImage },
  {
    type: "meta",
    property: "og:url",
    content: getCanonicalUrl(page, isTracker),
  },
  {
    type: "meta",
    property: "og:locale",
    content:
      getLanguage(getLocale(page.market))
  },
  { type: "meta", name:'geo.placename', content: process.env.PLACENAME },
  { type: "meta", name:'geo.region', content: process.env.COUNTRY },
  {
    type: "meta",
    name: "facebook-domain-verification",
    content: process.env.FBVERIFACTION,
  },
  {
    type: "meta",
    name: "robots",
    content:
      process.env.GATSBY_ACTIVE_ENV !== "development"
        ? page?.meta_robots?.join(",")
        : null,
  },
  { type: "meta", name: "twitter:title", content: twitterUsername && metaTitle },
  { type: "meta", name: "twitter:description", content: twitterUsername && parsedMetaDescr },
  { type: "meta", name: "twitter:site", content: twitterUsername && `@${twitterUsername}` },
  { type: "meta", name: "twitter:creator", content: twitterUsername && `@${twitterUsername}` },
  { type: "meta", name: "twitter:card", content: twitterUsername && 'summary' },
  { type: "meta", name: "twitter:image", content: twitterUsername && pageImage.replace('/filters:format(webp)', '') },
]
};
